import { render, staticRenderFns } from "./GrammarTablesPage.vue?vue&type=template&id=c94169c0&scoped=true&"
import script from "./GrammarTablesPage.vue?vue&type=script&lang=js&"
export * from "./GrammarTablesPage.vue?vue&type=script&lang=js&"
import style0 from "./GrammarTablesPage.vue?vue&type=style&index=0&id=c94169c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c94169c0",
  null
  
)

export default component.exports